// removed by extract-text-webpack-plugin
module.exports = {"Toggle":"Toggle---3i74N"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/Toggle.styl
// module id = tO9F
// module chunks = 89